<template>
	<div class="full">
		<div class="mine1">
			<div class="mine1_img12_img"><img src="../img/mine1_img12_img.jpg" /></div>
			<div class="mine1_img11_img" v-hammer:tap="ma"><img src="../img/mine1_img11_img.png" /></div>
			<div class="mine1_img10_img">
				<img src="../img/mine1_img10_img.png" />
				<div class="full" >
					<wx-open-launch-weapp class="launch-btn" id="launch-btn" username="gh_7ee3d23f0aa9"
						path="pages/games/store">
						<script type="text/wxtag-template">
							<style>.btn { width: 1000px; height: 1000px;}</style>
							<button class="btn" style="margin: auto;">打开小程序视频</button>
						</script>
					</wx-open-launch-weapp>
				</div>				
			</div>
			<div class="mine1_9" v-if="fudai.show">
				<div class="mine1_9_img4_img"><img src="../img/mine1_9_img4_img.png" /></div>
				<div class="mine1_9_img2_img" v-if="fudai.num<=fudai.isget"><img src="../img/mine1_9_img2_img.png" /></div>
				<div class="mine1_9_img3_img" v-else>
					<img src="../img/mine1_9_img3_img.png" />
					<div class="point flex">{{fudai.num - fudai.isget}}</div>
					<div class="full" >
						<wx-open-launch-weapp class="launch-btn" id="launch-btn" username="gh_7ee3d23f0aa9"
							path="pages/games/store">
							<script type="text/wxtag-template">
								<style>.btn { width: 1000px; height: 1000px;}</style>
								<button class="btn" style="margin: auto;">打开小程序视频</button>
							</script>
						</wx-open-launch-weapp>
					</div>					
				</div>
				<div class="mine1_9_img1_img"><img src="../img/mine1_9_img1_img.png" /></div>
			</div>
			<div class="mine1_8" v-if="hongbao.show">
				<div class="mine1_8_img4_img"><img src="../img/mine1_8_img4_img.png" /></div>
				<div class="mine1_8_img2_img"><img src="../img/mine1_8_img2_img.png" /></div>
				<div class="mine1_8_img1_img" v-if="hongbao.num<=hongbao.isget"><img src="../img/mine1_8_img1_img.png" /></div>
				<div class="mine1_8_img3_img" v-else v-hammer:tap="gethongbao">
					<img src="../img/mine1_8_img3_img.png" />
					<div class="point flex">{{hongbao.num - hongbao.isget}}</div>
<!-- 					<div class="full" >
						<wx-open-launch-weapp class="launch-btn" id="launch-btn" username="gh_7ee3d23f0aa9"
							:path="hongbaoPath">
							<script type="text/wxtag-template">
								<style>.btn { width: 1000px; height: 1000px;}</style>
								<button class="btn" style="margin: auto;">打开小程序视频</button>
							</script>
						</wx-open-launch-weapp>
					</div> -->					
				</div>
			</div>
			<div class="mine1_img7_img" v-hammer:tap="rule"><img src="../img/mine1_img7_img.png" /></div>
			<div class="mine1_img6_img" v-hammer:tap="back"><img src="../img/mine_back.png" /></div>
			<!-- <div class="mine1_img5_img"><img src="../img/mine1_img5_img.png" /></div> -->
			<div class="mine1_img4_img"><img :src="userInfo.headimgurl" /></div>
			<!-- <div class="mine1_img3_img"><img src="../img/mine1_img3_img.png" /></div> -->
			<div class="mine1_img2_img">{{userInfo.nickname}}</div>
			<div class="mine1_img1_img" v-hammer:tap="share" v-if="buttonShow"><img src="../img/mine1_img1_img.png" /></div>
		</div>
		
		<transition name="fade">
			<div class="full zhe ma_container flex" v-if="maShow" v-hammer:tap="maHide">
				<div class="ma" v-for="(item,index) in fudai.code" :key="index">
					<div class="ma_notice">若通过扫描门店分享的海报进入游戏<br/>可前往该门店兑换新春福袋</div>
					<div style="width: 40%;margin: auto;margin-top: 10px;">
						<vue-qr :text="gettext(item)" :size="300" :margin="10"></vue-qr>
					</div>
					<div class="code">{{item.code}}</div>
				</div>		
			</div>
		</transition>
		
		<transition name="fade">
			<rule v-if="ruleShow" @ruleBack="ruleBack"  />
		</transition>
		
		<transition name="fade">
			<box style="z-index: 999;" v-if="boxShow" @back="boxBack" />
		</transition>
				
		<transition name="fade">
			<abpage v-if="shareShow" v-hammer:tap="shareHide">
				<div class="full zhe">
					<div class="share_ele1"><img  src="../img/share_ele1.png"/></div>
				</div>
			</abpage>
		</transition>		
		<transition name="fade">
			<hb v-if="hbShow" @back="hbBack" />
		</transition>		
	</div>
</template>

<style scoped>
	.launch-btn {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		z-index: 9;
		overflow: hidden;
		opacity: 0;
	}	
.mine1_img12_img{position:absolute;left:0.00%;top:0.00%;width:100.00%;height:100.00%;}
.mine1_img11_img{position:absolute;left:20.27%;top:68.09%;width:24.66%;height:11.64%;}
.mine1_img10_img{position:absolute;left:60.27%;top:67.33%;width:19.33%;height:12.40%;}
.mine1_9_img4_img{position:absolute;left:15.51%;top:0.00%;width:68.97%;height:9.08%;}
.mine1_9_img3_img{position:absolute;left:0.00%;top:71.85%;width:100.00%;height:28.15%;}
.mine1_9_img2_img{position:absolute;left:0.00%;top:71.85%;width:100.00%;height:28.15%;}
.mine1_9_img1_img{position:absolute;left:10.67%;top:12.46%;width:78.66%;height:54.46%;}
.mine1_9{position:absolute;left:17.87%;top:31.59%;width:27.46%;height:24.55%;}
.mine1_8_img4_img{position:absolute;left:15.04%;top:0.00%;width:69.92%;height:9.34%;}
.mine1_8_img3_img{position:absolute;left:0.00%;top:71.93%;width:100.00%;height:28.07%;}
.mine1_8_img2_img{position:absolute;left:2.40%;top:13.53%;width:96.65%;height:51.91%;}
.mine1_8_img1_img{position:absolute;left:0.00%;top:71.93%;width:100.00%;height:28.07%;}
.mine1_8{position:absolute;left:55.07%;top:31.52%;width:27.46%;height:24.62%;}
.mine1_img7_img{position:absolute;left:77.07%;top:25.51%;width:18.80%;height:2.43%;}
.mine1_img6_img{position:absolute;left:0.00%;top:38.70%;width:17.07%;}
.mine1_img5_img{position:absolute;left:80.27%;top:64.32%;width:19.73%;height:9.78%;}
.mine1_img4_img{position:absolute;left:6.5%;top:14.3%;width:13.2%;height:6.3%;border-radius: 1000px;overflow: hidden;box-sizing: border-box;border: 2px solid white;}
.mine1_img3_img{position:absolute;left:23.33%;top:18.22%;width:11.47%;height:1.98%;}
.mine1_img2_img{position:absolute;left:23.33%;top:15.79%;font-size: 4vw;color: white;}
.mine1_img1_img{position:absolute;left:66.80%;top:15.28%;width:27.73%;height:5.56%;}
.mine1{position:absolute;left:0.00%;top:0.00%;width:100%;height:100%;}
.point{
	position: absolute;
	width: 16px;
	height: 16px;
	border-radius: 100px;
	background-color: red;
	color: white;
	font-size: 12px;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	right: -4px;
	top: -8px;
	
}
.ma_container{
	flex-direction: column;
	justify-content: center;
	align-items: center;
}
.ma{
	position: relative;
	width: 100%;
	margin-bottom: 50px;
}
.code{
	margin-top: 10px;
	color: white;
	text-align: center;
	font-size: 3vw;
	word-break: break-all;
	
}
.ma_notice{
	width: 100%;
	color: white;
	text-align: center;
	font-size: 4vw;
	font-weight: bold;
}
</style>
<script>
import vueQr from 'vue-qr'
	export default {
		data() {
			return {
				maShow:false,
				ruleShow:false,
				gift:[],
				fudai:{show:false,num:0,isget:0,code:[]},
				hongbao:{show:false,num:0,isget:0},
				shareShow:false,
				hongbaoPath:'',
				boxShow:false,
				buttonShow:false,
				hbShow:false
			};
		},
		computed: {
			userInfo(){
				return this.$store.state.userInfo
			}
		},
		created(){
			this.$api.isGameSuccess().then((res)=>{
				if(res==1){
					this.buttonShow = true
				}
			})
			this.getgift()
		},
		mounted() {

		},
		watch: {

		},
		methods: {
			gethongbao(){
				this.hbShow = true
			},
			hbBack(){
				this.hbShow = false
				this.getgift()
			},
			getgift(){
				this.$api.getgift().then((res)=>{
					this.fudai = {show:false,num:0,isget:0,code:[]}
					this.hongbao = {show:false,num:0,isget:0}
					this.gift = res
					this.gift.forEach((item)=>{
						if(item.gift==1){
							this.hongbaoPath = 'pages/games/money?unionId='+encodeURIComponent(this.userInfo.unionid)+'&bonusAmount='+item.bonusamount+'&actType=CNY'
							//console.log(this.hongbaoPath)
							this.hongbao.show = true
							this.hongbao.num ++
							if(item.isget==1){
								this.hongbao.isget++
							}

						}

						if(item.gift==2){
							this.fudai.show = true
							this.fudai.num ++
							if(item.isget==1){
								this.fudai.isget++
							}else{
								this.fudai.code.push({code:item.code,id:item.id})
							}
						}					
					})
					
				})				
			},
			gettext(item){
				let obj = {}
				obj.unionId = this.userInfo.unionid
				obj.giftid = item.id
				obj.code = item.code
				return JSON.stringify(obj)
			},
			ruleBack(){
				this.ruleShow = false
			},
			rule(){
				this.ruleShow = true
			},
			ma(){
				this.maShow = true
			},
			maHide(){
				this.maShow = false
				this.getgift()
			},
			share(){
				this.shareShow = false
				this.boxShow = true
				// this.shareShow = true
				// window._hmt.push(['_trackEvent', "share", "click"])
			},
			back(){
				this.$emit('back')
			},
			shareHide(){
				this.shareShow = false
				this.boxShow = true
				// this.$emit('back')
				// this.shareShow = false
				// this.$store.commit('setCurrentPage', {
				// 	page: 'p2'
				// })
			},
			boxBack(){
				this.boxShow = false
				this.getgift()
			}
		},
		components: {
			vueQr
		}
	}
</script>
